import { all, put, takeEvery } from "@redux-saga/core/effects";
import { checkQueryExists, createQuery } from "../../services/database";
import { throwError } from "../../services/error";
import { setErrorStatus } from "../status/actions";
import store from "../store/store";

export const queryActionTypes = {
  CREATE_QUERY: "CREATE_QUERY"
};

function* createQueryWorker(action) {
  try {
    yield put({ type: "SET_QUERY_LOADING", payload: { loading: true } });

    const { queryData, navigate } = action.payload;
    const { auth, documents, patients } = store.getState();
    const phoneNumber = auth.data.phoneNumber;
    let queryExists = false;

    if (typeof queryData?.document?.id === "string") {
      queryExists = yield checkQueryExists(queryData.document.id, phoneNumber);
    }

    if (queryExists) {
      throwError("custom", "Query already created for this document");
    }

    // Determine profileId
    const currentDocument = documents.currentDocument;
    const currentProfile =
      currentDocument?.to?.id && queryData.document?.id
        ? currentDocument.to.id
        : patients.currentProfile;

    const profile = patients.profiles?.[currentProfile];

    if (profile) {
      const data = {
        ...queryData,
        fullName: profile.name,
        phoneNumber: profile.phoneNumber,
        profileId: currentProfile,
        timestamp: Math.floor(Date.now() / 1000),
        userType: "patient",
        id: "/patientProfile"
      };
      yield createQuery(data);
      navigate("/querysuccess", { replace: true });
    }
  } catch (error) {
    setErrorStatus(error);
  } finally {
    yield put({ type: "SET_QUERY_LOADING", payload: { loading: false } });
  }
}

export default function* queryWatcher() {
  yield all([takeEvery("CREATE_QUERY", createQueryWorker)]);
}
